import React, {createContext, useEffect, useMemo, useState} from 'react'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation, Outlet} from 'react-router-dom'
import {MenuComponent} from '../assets/ts/components'
import {Layout} from 'antd'
import {useSelector} from 'react-redux'
import {isEmpty} from 'lodash'
import {IModuleModel} from 'src/app/modules/siteSettings/components/moduleManager/Model'
import {subRoutesToExclude} from './components/aside/AsideMenu'

function findTitleByPathname(pathname: string, routeData: any[]): string | null {
  for (const item of routeData) {
    // Check for direct match
    if (item.route === pathname) {
      return item.title
    }

    // Check within subRoutes if they exist
    if (item.subRoutes) {
      for (const sub of item.subRoutes) {
        if (sub.route === pathname) {
          return sub.title
        }
      }
    }
  }

  return null // not found
}

export const ActiveMenuContex = createContext<any>({})

const MasterLayout: React.FC = () => {
  const location = useLocation()
  const module: any = useSelector((state: any) => state.auth.module)

  const {pathname} = useLocation()
  const routeData = !isEmpty(module?.moduleData)
    ? module?.moduleData.map((parentData: any) => ({
        route: parentData.alias,
        title: parentData.name,
        subRoutes: parentData?.children
          ?.filter((item: any) => {
            return !subRoutesToExclude.includes(item?.alias)
          })
          .map((childrenData: IModuleModel) => ({
            route: childrenData.alias,
            title: childrenData.name,
          })),
      }))
    : []
  const title = useMemo(() => findTitleByPathname(pathname, routeData), [pathname, routeData])

  const [currentActiveMenu, setCurrentActiveMenu] = useState(title || '')
  const [open, setOpen] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <>
      <PageDataProvider>
        <ActiveMenuContex.Provider value={{currentActiveMenu, setCurrentActiveMenu, open, setOpen}}>
          <Layout>
            <HeaderWrapper />
            <Layout>
              <AsideDefault />
              <Layout style={{padding: '24px 0'}}>
                <Content>
                  <Outlet />
                </Content>
              </Layout>
            </Layout>
          </Layout>
          <ScrollTop />
        </ActiveMenuContex.Provider>
      </PageDataProvider>
    </>
  )
}

export {MasterLayout}
